// Reset any text styles for clearer type
// $(function() {
//   $("h1,h2,h3,h4,h5,p,span,a").css("font-weight", "normal");
// });

// Force Squares Collections on Mobile
// $(function() {
//   if ( $(window).width() < 900 ) {
//     var collectionItemWidth = $(".collection-item").width();
//     $(".collection-item, .collection-item .bg-image img").css("height", collectionItemWidth);
//   }
// });



// Stop Shopify wrapping images and videos with p tags
$(function () {
  // Unwrap images and videos for better styling
  $('.article-template img').unwrap("p");
  $('.article-template iframe').unwrap("p");
  // Remove any empty p tags that might break layout
  $('.article-template p, .article-template span').each(function() {
    var $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
        $this.remove();
  });
  // If image has alt text, create a span caption beneath
  $(".article-template .article-body-content img").each(function(){
    if ( $(this).attr('alt') ) {
      var img = $(this);
      var span = $("<span/>");
      span.text(img.attr("alt"));
      img.after(span);
    }
  });

  // Remove all anoying shopify inline styles
  $(".article-template p").removeAttr('style');

  // Override grid to match article content : )
  $(".article-template .heading").css("max-width", "650px");
  $(".article-template .heading").css("margin-left", "auto");
  $(".article-template .heading").css("margin-right", "auto");
  $(".article-template .heading").css("flex-basis", "100%");
});



// Find/replace names
$(function () {
  $(".article-info p strong").each(function () {
    var text = $(this).text();
    $(this).text(text.replace("Rad Dev", "Egon"));
  });
});

// Dynamic padding based on Header
$(function () {
  var headerHeight = $("#site-header").height();
  var remValue = 16;
  var remValueDouble = remValue * 2;
  var pagePaddingTop = headerHeight + remValueDouble;
  var pagePaddingTopRounded = Math.round(pagePaddingTop);
  // Set Body Padding when !index
  if (!$("body").hasClass("index")) {
    $("body").css("padding-top", pagePaddingTopRounded);
    $("main").css(
      "min-height",
      $(window).height() - pagePaddingTopRounded * 1.75
    );
  }


  // is ! mobile ?
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    // Set Footer height
    var logoRevealHeight = $(".logo-reveal").height();
    var windowHeight = $(window).height();
    var footerDynamicHeight = windowHeight - logoRevealHeight;
    // Set footer height
    $("#site-footer").css("min-height", footerDynamicHeight);
  }
});

$( window ).resize(function() {
  $(function () {
    var headerHeight = $("#site-header").height();
    var remValue = 16;
    var remValueDouble = remValue * 2;
    var pagePaddingTop = headerHeight + remValueDouble;
    var pagePaddingTopRounded = Math.round(pagePaddingTop);
    // Set Body Padding when !index
    if (!$("body").hasClass("index")) {
      $("body").css("padding-top", pagePaddingTopRounded);
      $("main").css(
        "min-height",
        $(window).height() - pagePaddingTopRounded * 1.75
      );
    }

    // is ! mobile ?
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      // Set Footer height
      var logoRevealHeight = $(".logo-reveal").height();
      var windowHeight = $(window).height();
      var footerDynamicHeight = windowHeight - logoRevealHeight;
      // Set footer height
      $("#site-footer").css("min-height", footerDynamicHeight);
    }
  });
});





// Menu stuff
$(function () {
  // Explore
  $(".explore-link").click(function () {
    $(".filter-menu").removeClass("open");
    $(".menu div").fadeOut();
    setTimeout(function () {
      $(".explore-menu").toggleClass("open");
    }, 200);
  });
  // Filter
  $(".filter-link").click(function () {
    $(".explore-menu").removeClass("open");
    $(".menu div").fadeOut();
    setTimeout(function () {
      $(".filter-menu").toggleClass("open");
    }, 200);
  });
  // Filter
  $(".mobile-menu-link").click(function () {
    $(".icons").fadeOut();
    $(".menu div").fadeOut();
    setTimeout(function () {
      $(".mobile-menu").toggleClass("open");
    }, 200);
  });

  // Close
  $("#site-header").click(function () {
    if ($(".sliding-menu.open").length) {
      $(".icons").fadeIn();
      $(".menu div").fadeIn();
      $(".sliding-menu").removeClass("open");
    }
  });
});

// Hide pop out menu on scroll
if ( $(window).width() > 800 ) {

  $(window).scroll(function () {
    if ($(".sliding-menu.open").length) {
      $(".icons").fadeIn();
      $(".menu div").fadeIn();
      $(".sliding-menu").removeClass("open");
    }
  });

}


// Click logo footer to scroll top
$(function () {
  $(".logo-reveal").click(function (e) {
    e.preventDefault();
    window.scrollTo(0, 0);
  });
});

// Signup Popup form
$(document).ready(function () {
  // Show on body.index scroll
  $(window).scroll(function () {
    // Show oin scroll
    if ($(window).scrollTop() > 100) {
      $(".homepage-subscribe").addClass("opened");
    }

    // Hide when near bottom of page
    if (
      $(window).scrollTop() + $(window).height() >
      $(document).height() - 100
    ) {
      $(".homepage-subscribe").removeClass("opened");
      $(".homepage-subscribe").addClass("closed");

      if ($(window).width() < 800) {
        $("#site-header").css("opacity", 0);
      }
    } else {
      $("#site-header").css("opacity", 1);
    }
  });

  // Hide on click
  $(function () {
    $(".close-signup").click(function () {
      $(".homepage-subscribe").removeClass("opened");
      $(".homepage-subscribe").addClass("closed");
    });
  });
});

// Products swatches
$(function () {
  // Unselect default 1st option
  $("body.product input:checked").prop("checked", false);
  $("body.product .product__form button").prop("disabled", true);
  // Update button style on click
  $("body.product label").click(function () {
    $("body.product .product__form button").prop("disabled", false);
    $("body.product .product__form button").removeClass("passive-button");
    $("body.product .product__form button").addClass("active-button");
  });

  $(".single-button-wrapper button").prop("disabled", false);
});

// Dropdown selector menu jQuery UI
$(function () {
  $("body.product .product__form button").prop("disabled", true);
  $("#product-dropdown").selectmenu({
    change: function (event, ui) {
      $("body.product .product__form button").prop("disabled", false);
      $("body.product .product__form button").removeClass("passive-button");
      $("body.product .product__form button").addClass("active-button");
    },
  });

  $(".single-button-wrapper button").prop("disabled", false);
});




$(function () {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {


    setTimeout(function() {
      var collectionItemWidth = $(".collection-item").width();
      // $(".collection-item, .collection-item .bg-image img").css("height",collectionItemWidth);
      $(".collection-item, .collection-item .bg-image").css("height",collectionItemWidth);
    }, 500);

    $(".collection-item").addClass("isPhone");
    $(".button-row a").addClass("isPhone");
    $(".homepage-product-row").addClass("isPhone");
  }
});



// Change product image view from full to half width if > 3
$(function () {
  var productImageCount = $(".product-images").children().length;
  if (productImageCount > 2) {
    $(".product-images").addClass("image-grid");
  }
});


// Stop prouct featured image repeating when we move video to the top
$(function () {
  if ( $(window).width() < 800 ) {
    if ($(".product-images").find("video").length) {
      $(".product-images").children().eq(1).hide();
    }
  }
});






// Product Page Shipping Info Popup
$(function() {
  // if($("body").hasClass("product") ) {}

  $(".shipping-link").click(function () {
    $(".menu div, .icons").fadeOut();
    // $("body").addClass("body-menu-open");
    setTimeout(function () {
      $(".shipping-info-popup").addClass("popup-open");
      $(".close-shipping").addClass("show-icon");
    }, 100);
  });


});


$(function() {
  // if($("body").hasClass("body-menu-open") ) {}
  $(".close-shipping").click(function () {
    $(".menu div, .icons").fadeIn();
    $("html, body").animate({ scrollTop: 0 }, 0);
    setTimeout(function () {
      $(".shipping-info-popup").removeClass("popup-open");
      $(".close-shipping").removeClass("show-icon");
    }, 100);
  });
});


$(function() {
  var dropdownButtonWidth = $("#product-dropdown-button").width();
  $('#product-dropdown-menu').css('max-width', dropdownButtonWidth);
})


$(document).ready(function () {
  $("#account-recovery-link").click(function () {
    $('#account-login').addClass('hidden-section');
    $('#account-recovery').removeClass('hidden-section');
  });
});







// Address page

// Give pages nice min-hieght : )
// $(function() {
//   var footerHeight = $("#site-footer").height();
//   var docHeight = $(window).height();
//   var mainHeight   = (docHeight - footerHeight) - 150;
//
//   $("main").css("min-height", mainHeight);
// });

// Product Dropdown
// via jquery UI
// $(function() {
//   $("#AddToCartForm")
//     .selectmenu()
//     .selectmenu("menuWidget")
//     // .addClass("overflow");
// });

// Splash Screen
// $(function() {
//   setTimeout(function() {
//     $('.splash').fadeOut();
//   }, 1000);
// });

// Lazy Loading
// $(function($) {
//   $('img.lazy').Lazy({
//     // Load Images with fade
//     scrollDirection: 'vertical',
//     visibleOnly: false,
//     effectTime: 100,
//     effect: "fadeIn",
//     // Unblur images after load
//     afterLoad: function(element) {
//       element.addClass('loaded');
//     }
//   });
// });

// Init Slider
// $('.slider').slick({
//   speed: 100,
//   fade: true,
//   dots: false,
//   arrows: false,
//   autoplay: true,
//   infinite: true,
//   autoplaySpeed: 50,
//   pauseOnFocus: false,
//   pauseOnHover: false,
// });

// Product Dropdown jQuery UI
// $(function() {
//   $("#select-product-option")
//     .selectmenu()
//     .selectmenu("menuWidget")
//     // .addClass("overflow");
// });

// window.onscroll = function(ev) {
//   if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
//     $(".logo-reveal").removeClass("visable");
//   } else {
//     $(".logo-reveal").addClass("visable");
//   }
// };
